import styled from 'styled-components';

export const Container = styled.div`
  .back-link {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: none;
    border: none;
    padding: 0;
    color: #007bff;
    font-size: 0.85rem;
    cursor: pointer;
    margin-bottom: 16px;
  }

  .back-link .material-icons {
    font-size: 18px;
  }

  .detail-card {
    border: 1px solid #ced4da;
    border-radius: 8px;
    padding: 20px;
    max-width: 1000px;
    margin: 0 auto;
  }

  .detail-thumb {
    position: relative;
    width: 100%;
    padding-top: 40%;
    background: #01080c center/cover no-repeat;
    border-radius: 6px;
    overflow: hidden;
    margin-bottom: 14px;
  }

  .detail-thumb img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .badges {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 12px;
  }

  .badge-pill {
    background: #28a745;
    color: #fff;
    font-size: 0.7rem;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 4px;
  }

  .detail-body {
    display: flex;
    gap: 32px;
  }

  .detail-main {
    flex: 1;
    min-width: 0;
  }

  .detail-title {
    font-size: 1.15rem;
    font-weight: 600;
    color: #000;
    margin-bottom: 10px;
  }

  .detail-description {
    font-size: 0.95rem;
    font-weight: 400;
    color: #000;
    white-space: pre-line;
    line-height: 1.6;
  }

  .detail-side {
    flex-shrink: 0;
    width: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }

  .date-box {
    width: 80px;
    height: 88px;
    background: #f3f3f3;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }

  .date-box .day {
    font-size: 1.6rem;
    font-weight: 600;
    color: #000;
  }

  .date-box .month {
    font-size: 0.8rem;
    font-weight: 600;
    color: #000;
    margin-top: 4px;
  }

  .side-datetime {
    font-size: 0.85rem;
    color: #000;
    text-align: center;
  }

  .empty-state {
    text-align: center;
    color: #888;
    padding: 60px 20px;
  }

  .loading-wrapper {
    display: flex;
    justify-content: center;
    padding: 60px 0;
  }

  @media (max-width: 640px) {
    .detail-body {
      flex-direction: column;
      gap: 20px;
    }

    .detail-side {
      width: 100%;
      flex-direction: row;
      justify-content: flex-start;
    }
  }
`;
